import { useState } from "react";
import { PartnerCompanyDetails } from "../../types/PartnerCompanyDetails";
import CustomModal from "../DealTracker/CustomModal";
import { CrossIcon } from "../Icons";
import { capitalizeFirstLetter } from "../../utils";
import PartnerCompanyForm from "./PartnerCompanyForm";

export default function PartnerCompanyBtn({
  children,
  className,
  action,
  selectedCompany,
}: {
  children: React.ReactNode;
  className: string;
  action: "add" | "update";
  selectedCompany?: PartnerCompanyDetails;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen((prev) => !prev);

  return (
    <div>
      <button type="button" className={className} onClick={toggleModal}>
        {children}
      </button>

      <CustomModal
        open={isOpen}
        onClose={toggleModal}
        className="w-full max-w-2xl p-4 rounded-md bg-white backdrop:bg-black/50"
      >
        <button type="button" className="float-end" onClick={toggleModal}>
          <CrossIcon className="size-8 text-[#1A1D21]" />
        </button>
        <div className="mb-4">
          <h2 className="text-lg text-gray-800 font-medium">
            {capitalizeFirstLetter(action)} Partner Company Details
          </h2>
          <p className="text-xs text-gray-600">
            Add or edit partner company details such as name, contact, and
            address to keep your records accurate and current.
          </p>
        </div>
        <PartnerCompanyForm
          action={action}
          toggleModal={toggleModal}
          selectedCompany={selectedCompany}
        />
      </CustomModal>
    </div>
  );
}
